export default "__VITE_ASSET__a2a6e68f__"